export enum ProductStatus {
  PRE_RELEASE = 40,
  ACTIVE = 50,
  RUN_DOWN = 60,
  USE_UP = 70,
  RETURNS_REBATE = 80,
  INACTIVE = 90,
  UNAVAILABLE = -1,
}
